module.exports = __webpack_public_path__ + "img/h3-video.57c02054.jpg";